/**
 *
 * @param selector
 * @param events
 * @param handler
 *
 * @returns { event, targetElement}
 */
export function addCustomEventListener ( selector, events, handler )
{
    const rootElement = document.querySelector( 'body' );


    if ( !Array.isArray( events ) )
    {
        events = [ events ];
    }
    // console.log( 'events:after', events )
    events.forEach( ( event ) =>
    {

        // console.log( 'Binding ', event, selector )

        //since the root element is set to be body for our current dealings
        rootElement.addEventListener( event, function ( evt )
            {
                let targetElement = evt.target;

                while ( targetElement != null )
                {

                    if ( targetElement.matches( selector ) )
                    {

                        // console.log( 'Found the target ', targetElement );
                        handler( evt, targetElement );
                        return evt;
                    }
                    targetElement = targetElement.parentElement;

                }
                return evt;
            },
            true,
        );
    } );
}

export function setupSmoothScrollTo ()
{
    addCustomEventListener( '.smooth-scroll-jump', 'click', ( e ) =>
    {

        const clicked     = e.target;
        const anchor      = clicked.getAttribute( 'href' );
        const destination = document.querySelector( anchor );

        if ( !destination )
        {
            return;
        }

        e.preventDefault();

        const y               = destination.getBoundingClientRect().top;
        const headerHeight    = document.querySelector( '#reservations_steps_nav' ).getBoundingClientRect().height;
        const jumpLinksHeight = document.querySelector( '.sub-tab-menu-spacer' ).getBoundingClientRect().height;

        const wantedY = y + window.scrollY - headerHeight - jumpLinksHeight;


        window.scrollTo( {
            top      : wantedY,
            left     : 0,
            behavior : 'smooth',
        } );

    } )
}


export function showNewsletter ()
{


    const newsletterOverlay = document.querySelector( '#newsletter_overlay' );
    const newsletter        = document.querySelector( 'section.newsletter' );

    if ( document.body.classList.contains( 'newsletter_opened' ) )
    {
        hideNewsletter();
    }


    newsletterOverlay.style.display = 'block';

    document.body.classList.add( 'newsletter_opened' );
    TweenMax.to( newsletter, 0.5, { left : 0 } );
}


export function hideNewsletter ()
{


    const newsletterOverlay = document.querySelector( '#newsletter_overlay' );
    const newsletter        = document.querySelector( 'section.newsletter' );

    document.body.classList.remove( 'newsletter_opened' );


    newsletterOverlay.style.display = 'none';

    TweenMax.to( newsletter, 0.5, { left : '100%' } );
}


export function submitNewsletter ()
{

}



/**
 *
 * @param {string}          eventName
 * @param {boolean|object}  detail
 */
export function dispatchWindowEvent ( eventName, detail = false )
{

    let event;

    if ( detail )
    {
        event = new CustomEvent( eventName, { detail } );
    } else
    {
        event = new CustomEvent( eventName );
    }


    window.dispatchEvent( event );
}



/**
* @param {HTMLElement} element
* @param {number} viewportTopAdjustment
* @returns {number} percent of element in view
*/
export function getPercentOfView(element, viewportTopAdjustment = 0) {

    const viewTop = window.pageYOffset + viewportTopAdjustment;
    const viewBottom = viewTop + window.innerHeight;
    const rect = element.getBoundingClientRect();
    const elementTop = rect.top + viewTop;
    const elementBottom = elementTop + rect.height;

    if (elementTop >= viewBottom || elementBottom <= viewTop) {
        // heigher or lower than viewport
        return 0;
    } else if (elementTop <= viewTop && elementBottom >= viewBottom) {
        // element is completely in viewport and bigger than viewport
        return 1;
    } else if (elementBottom <= viewBottom) {
        if (elementTop < viewTop) {
            // intersects viewport top
            return (elementBottom - viewTop) / window.innerHeight;
        } else {
            // completely inside viewport
            return (elementBottom - elementTop) / window.innerHeight ;
        }
    } else {
        // intersects viewport bottom
        //  elementBottom >= viewBottom && elementTop <= viewBottom
        return ( viewBottom - elementTop) / window.innerHeight ;
    }
}
